import { QueovalBase, InfoBo, QueovalDik, QueovalDate} from '../global';
import { BlockItem, BlockFile } from '../blocked';

import { Corporation } from './action-co.model';
import { ModelMail } from '../mail';
//import { ModelMail } from '../elearning';

export class ActionCoMailModel extends QueovalBase {
  constructor() {
    super();
    this.Model = new ModelMail();
    this.attachmentToPdf = true;
  }
  public GED: BlockItem;
  public LstQueovalDik: Array<QueovalDik>;
  public Documents: Array<BlockFile>;
  public Contacts: Array<ContactMail>;
  public Model: ModelMail;
  public Programed: QueovalDate;
  public Attachments: { [key: string]: string };
  public attachmentToPdf: boolean;
  public NewDocument: BlockFile;

  // Données complémentaires pour l'historique
  public Customer: Corporation;
  public idActionCo: string;
}
export class ContactMail {
  public Id: string;
  public Name: string;
  public Mails: Array<QueovalDik>;
  public Tels: Array<QueovalDik>;
}


